import { DataType } from '../meta/basetype';
import { InjectionToken } from '@angular/core';

/**
 * å®ä½å±æ§å®ä¹
 * @export
 */
export interface ColumnDef {
    name?: string;
    type?: DataType;
    ref?: string;
    caption?: string;
    inputer?: string;
    len?: number;
    format?: string;
    ret?: string;
}

/**
 * å®ä½å®ä¹
 * @export
 */
export interface TableDef {
    /**
     * å®ä½åç§°
     * @memberOf TableDef
     */
    name?: string;
    /**
     * å®ä½ä¸­æåç§°
     * @memberOf TableDef
     */
    title: string;
    /**
     * å®ä½IDå±æ§
     * @memberOf TableDef
     */
    idProp?: string;
    /**
     * å®ä½åç§°å±æ§
     * @memberOf TableDef
     */
    nameProp: string;
    /**
     * å®ä½REST-BASE URL
     * @memberOf TableDef
     */
    url: string;

    filter?: object;
    search?: string;
    sortProp?: string;
    /**
     * å®ä½æéåç¼ï¼é»è®¤ä¸ºå®ä½åç§°ï¼å¦dept
     * @memberOf TableDef
     */
    pmPrefix?: string;
    /**
     * å®ä½è¯»æéï¼é»è®¤ä¸º <name>.read,å¦ï¼dept.read
     * @memberOf TableDef
     */
    pmRead?: string;
    /**
     * å®ä½æ°å¢æéï¼é»è®¤ä¸º <name>.add,å¦ï¼dept.add
     * @memberOf TableDef
     */
    pmAdd?: string;
    /**
     * å®ä½ä¿®æ¹æéï¼é»è®¤ä¸º <name>.edit,å¦ï¼dept.edit
     * @memberOf TableDef
     */
    pmEdit?: string;
    /**
     * å®ä½å é¤æéï¼é»è®¤ä¸º <name>.delete,å¦ï¼dept.delete
     */
    pmDelete?: string;
    properties?: { [propName: string]: ColumnDef };
    customDefined?: boolean;
    // å¯¹åºçæµç¨åç§°
    flowName?: string;
    cachable?: boolean;
}

// tslint:disable-next-line:no-empty-interface
export interface MetaData {
    // [entName: string]: TableDef;
}

/**
 * ç³»ç»éç½®ï¼ä¸»è¦ç¨äºååç«¯çè¿æ¥URL
 * @export
 */
export interface AppConfig {
    baseUrl: string;
    //loginUrl: string;
    //logoutUrl: string;
    //getUserInfoUrl?: string;
    config?: any;

    clientLoginUrl?: string;

    loginSettingUrl?: string;

    standAlone?: boolean;
    getEntity?: (entityName: string) => TableDef;
    metaDatas?: MetaData;
    metaApiUrl?: string;
    taskProgressApiUrl?: string;
}

/**
 * ç³»ç»éç½®TOKENï¼ç¨äºAppConfigæ³¨å¥
 */
export const APP_CONFIG = new InjectionToken<AppConfig>('AppConfig');

// export abstract class AppConfig {
//     abstract get baseUrl(): string;
//     abstract get loginUrl(): string;
//     abstract get logoutUrl(): string;
//     abstract get getUserInfoUrl(): string;

//     abstract get clientLoginUrl(): string;

//     abstract getEntity(entityName: string): TableDef;
//     abstract get metaDatas(): MetaData;
// }

